import React from 'react';

// Extend the default component from the library so the build will fail if we have a slice without a matching component
// https://github.com/prismicio/prismic-react/blob/master/src/SliceZone.tsx
const DefaultComponent = ({ slice }) => {
  const type = slice.slice_type;
  if (process.env.NODE_ENV === 'development') {
    return (
      <section data-slice-zone-todo-component="" data-slice-type={type}>
        Could not find a component for Slice type &ldquo;{type}
        &rdquo;
      </section>
    );
  } else {
    // Temporarily commented out 19.10 (builds were failing due prior launch day)
    // If you see this and we haven't remembered to comment it back in, you can re-enable this
    // throw new Error(`Slice with a type "${type}" doesn't have a matching component to render it.`);
  }
};

export default DefaultComponent;
